import { render } from "./_PartialsPortfolio.vue?vue&type=template&id=c6e4517e&scoped=true"
import script from "./_PartialsPortfolio.vue?vue&type=script&lang=js"
export * from "./_PartialsPortfolio.vue?vue&type=script&lang=js"

import "./_PartialsPortfolio.vue?vue&type=style&index=0&id=c6e4517e&lang=scss&scoped=true"

import exportComponent from "/home/ec2-user/src/FVC.frontend/Public/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6e4517e"]])

export default __exports__